import React, { PureComponent, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ISOCurrencyCovert } from '../../../helpers/locationHelper';
import dayjs from 'dayjs';
import _filter from 'lodash/filter';
import Toggle from 'react-toggle';
import { PostIntinerariesAccomodation } from '../../../actions/itineraries';
import { removeByLastIndex } from '../../../helpers/stringutils';
import { CYOA_NETWORK_IDS } from '../../../config';

class Infobar extends PureComponent {

  constructor(props){
    super(props);
    this.state = {
      totalBreakdownVisible:window.matchMedia("(min-width: 40em)").matches ? false : true,
      toggleCheck:props.itineraries.accomm_global_room_type === "none" ? false : true
    }
    this.onEditClicked = this.onEditClicked.bind(this);
    this.onBookClicked = this.onBookClicked.bind(this);
    this.onItineraryClicked = this.onItineraryClicked.bind(this);
    this.totalMouseOut = this.totalMouseOut.bind(this);
    this.totalMouseOver = this.totalMouseOver.bind(this);
    this.openShareModal = this.openShareModal.bind(this);
    this.handleToggleChange = this.handleToggleChange.bind(this);
  }

  componentDidMount(){
    this.setState({toggleCheck: this.props.itineraries.accomm_global_room_type === "none" ? false : true });
  }

  handleToggleChange(){
    this.setState({toggleCheck: !this.state.toggleCheck}, () => {
      const roomType = !this.state.toggleCheck ? 'none' : 'default';
      this.props.PostIntinerariesAccomodation(this.props.itineraries, true, true, this.state.toggleCheck, roomType);
    });
  }

  openShareModal(){ this.props.openShareModal(); }

  onBookClicked(){
    if(this.props.itineraries.total_paid  === "0.00"){
      this.props.openModal();
    }
  }

  onEditClicked(){
    this.props.openEdit();
  }

  onItineraryClicked(){
    this.props.openModal();
  }

  totalMouseOut(){ if(window.matchMedia("(min-width: 40em)").matches) this.setState({totalBreakdownVisible:false}); }
  totalMouseOver(){ if(window.matchMedia("(min-width: 40em)").matches) this.setState({totalBreakdownVisible:true}); }


  render(){

    const { totalBreakdownVisible, toggleCheck } = this.state;
    const { itineraries:{content:{nr_pax, nr_days, nr_cities, nr_stops, date_start, date_end}, iso_currency, trips, discount,  grand_total, sectors, total_paid, tms_group_booking_id, created_at, accomm_total } } = this.props;

    let CYO_PRICE =  (parseFloat(trips[0].passengers[0].price) + parseFloat(trips[0].passengers[0].accomm_price) - parseFloat(trips[0].passengers[0].discount));

    return (
      <Fragment>
      <div
        className={`cyao-price-breakdown ${discount === "0.00" ? 'no-discount' : '' } ${total_paid === "0.00" ? "" : "confirmed" }`}
        style={{display:totalBreakdownVisible ? 'block' : 'none' }}
        onMouseOut={() => this.totalMouseOut()}
        onMouseOver={() => this.totalMouseOver()}
        >
          <div className="row">
            <div className="column small-8">
              <h6 className="busabout-h6">
                <span style={{display: total_paid === "0.00" ? 'block' : "none"}}>Booking Summary</span>
                <span style={{display: total_paid !== "0.00" ? 'block' : "none"}}>Payment Summary</span>
              </h6>
            </div>

            <div className="column small-4">
              <button className="share-button" type="button" onClick={this.openShareModal}>

              <svg xmlns="http://www.w3.org/2000/svg" width="77.598" height="57.736" viewBox="0 0 77.598 57.736">
                <g data-name="Layer 2">
                  <g data-name="Layer 1">
                    <path d="M22.53 19.968a2 2 0 0 1-2-2 12.915 12.915 0 0 1 12.899-12.9c.354 0 .705.015 1.052.042a11.337 11.337 0 0 1 4.662 1.41 2 2 0 1 1-1.957 3.489 7.356 7.356 0 0 0-3.026-.911 9.456 9.456 0 0 0-.731-.03 8.91 8.91 0 0 0-8.9 8.9 2 2 0 0 1-2 2zM31.907 34.69a2 2 0 0 1-1.435-3.393l4.237-4.37a2 2 0 0 1 2.871 2.785l-4.237 4.37a1.994 1.994 0 0 1-1.436.608z"/>
                    <path d="M13.177 34.69a1.995 1.995 0 0 1-1.469-.642l-1.627-1.759-6.598-6.963A12.26 12.26 0 0 1 1.117 11.71a11.487 11.487 0 0 1 9.48-6.599c.35-.028.702-.043 1.056-.043a12.915 12.915 0 0 1 12.9 12.9 2 2 0 1 1-4 0 8.91 8.91 0 0 0-8.9-8.9c-.247 0-.493.011-.736.03a7.527 7.527 0 0 0-6.194 4.342 8.24 8.24 0 0 0 1.663 9.134l8.257 8.757a2 2 0 0 1-1.467 3.358zM22.53 44.267a1.994 1.994 0 0 1-1.415-.586l-4.556-4.558a2 2 0 0 1 2.828-2.828l4.556 4.557a2 2 0 0 1-1.414 3.415z"/>
                    <path d="M22.554 44.267a2 2 0 0 1-1.414-3.415l4.557-4.557a2 2 0 0 1 2.828 2.828l-4.557 4.558a1.994 1.994 0 0 1-1.414.586zM51.781 39.617A19.809 19.809 0 1 1 71.59 19.81 19.81 19.81 0 0 1 51.78 39.617zm0-35.617A15.809 15.809 0 1 0 67.59 19.809 15.766 15.766 0 0 0 51.78 4z"/>
                    <path d="M51.68 31.59a10.118 10.118 0 0 1-9.595-6.934 2 2 0 1 1 3.793-1.27 6.107 6.107 0 0 0 11.755-.535 2 2 0 0 1 3.895.91 10.208 10.208 0 0 1-9.848 7.829zM75.525 57.736H28.036a2 2 0 0 1-1.955-1.577c-.578-2.672 1.02-6.931 3.979-10.6 2.902-3.598 9.582-9.632 21.72-9.632s18.82 6.036 21.722 9.633c2.958 3.668 4.557 7.928 3.978 10.6a2 2 0 0 1-1.955 1.576zm-45.379-4h43.27a15.546 15.546 0 0 0-3.027-5.665c-2.453-3.04-8.133-8.143-18.609-8.143s-16.154 5.101-18.606 8.143a15.552 15.552 0 0 0-3.027 5.665zM22.53 19.968a2 2 0 0 1-2-2 12.915 12.915 0 0 1 12.899-12.9c.354 0 .705.015 1.052.042a11.337 11.337 0 0 1 4.662 1.41 2 2 0 1 1-1.957 3.489 7.356 7.356 0 0 0-3.026-.911 9.456 9.456 0 0 0-.731-.03 8.91 8.91 0 0 0-8.9 8.9 2 2 0 0 1-2 2zM31.907 34.69a2 2 0 0 1-1.435-3.393l4.237-4.37a2 2 0 0 1 2.871 2.785l-4.237 4.37a1.994 1.994 0 0 1-1.436.608z"/>
                    <path d="M13.177 34.69a1.995 1.995 0 0 1-1.469-.642l-1.627-1.759-6.598-6.963A12.26 12.26 0 0 1 1.117 11.71a11.487 11.487 0 0 1 9.48-6.599c.35-.028.702-.043 1.056-.043a12.915 12.915 0 0 1 12.9 12.9 2 2 0 1 1-4 0 8.91 8.91 0 0 0-8.9-8.9c-.247 0-.493.011-.736.03a7.527 7.527 0 0 0-6.194 4.342 8.24 8.24 0 0 0 1.663 9.134l8.257 8.757a2 2 0 0 1-1.467 3.358zM22.53 44.267a1.994 1.994 0 0 1-1.415-.586l-4.556-4.558a2 2 0 0 1 2.828-2.828l4.556 4.557a2 2 0 0 1-1.414 3.415z"/>
                    <path d="M22.554 44.267a2 2 0 0 1-1.414-3.415l4.557-4.557a2 2 0 0 1 2.828 2.828l-4.557 4.558a1.994 1.994 0 0 1-1.414.586zM51.781 39.617A19.809 19.809 0 1 1 71.59 19.81 19.81 19.81 0 0 1 51.78 39.617zm0-35.617A15.809 15.809 0 1 0 67.59 19.809 15.766 15.766 0 0 0 51.78 4z"/>
                    <path d="M51.68 31.59a10.118 10.118 0 0 1-9.595-6.934 2 2 0 1 1 3.793-1.27 6.107 6.107 0 0 0 11.755-.535 2 2 0 0 1 3.895.91 10.208 10.208 0 0 1-9.848 7.829zM75.525 57.736H28.036a2 2 0 0 1-1.955-1.577c-.578-2.672 1.02-6.931 3.979-10.6 2.902-3.598 9.582-9.632 21.72-9.632s18.82 6.036 21.722 9.633c2.958 3.668 4.557 7.928 3.978 10.6a2 2 0 0 1-1.955 1.576zm-45.379-4h43.27a15.546 15.546 0 0 0-3.027-5.665c-2.453-3.04-8.133-8.143-18.609-8.143s-16.154 5.101-18.606 8.143a15.552 15.552 0 0 0-3.027 5.665z"/>
                  </g>
                </g>
              </svg>
              
                Share
              </button>
            </div>

            <div className="column small-12">
              <p className="bookref-text">
              Booking Quote Ref: {tms_group_booking_id} 
              <span style={{display: total_paid === "0.00" ? 'inline' : "none"}}> | Expiry Date:  { dayjs(removeByLastIndex(created_at, " ")).add('7', 'days').format('DD MMMM YYYY') }</span>
              </p>
            </div>

          </div>

          <div className="row">
            <div className="column small-12">

              <div className="breakdown-dates">
                <svg className="calendar-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                  <path d="M148 288h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zm108-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm96 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm-96 96v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm-96 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm192 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm96-260v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48zm-48 346V160H48v298c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"/>
                </svg>
                { dayjs(date_start).format('DD MMMM') } &nbsp;
                &rarr;
                &nbsp; { dayjs(date_end).format('DD MMMM YYYY') }
              </div>

            </div>
          </div>
          <hr/>
          <div className="row margin-t-30 margin-b-10">
            <div className="column small-8 text-left">
              <p className="bold">
                <span className="roundal"></span>
                { sectors[0].city } to { sectors[sectors.length - 1].city }
              </p>

              { trips[0].descriptions.map((item, i) => { return <p className="left-space small" key={i}>{item}</p> }) }

              <p className="left-space small orange-link" onClick={this.onBookClicked} style={{display: total_paid === "0.00" ? 'inline-block' : "none"}}>Edit Accommodation</p>

            </div>
            <div className="column small-4 text-right">
              <p>
                {ISOCurrencyCovert(iso_currency)}{CYO_PRICE.toFixed(2)}&nbsp;<span className="currency">{iso_currency}</span>
              </p>
              <label className="margin-t-20" style={{display: total_paid === "0.00" ? 'block' : "none"}}>
                <Toggle defaultChecked={toggleCheck} onChange={this.handleToggleChange} />
              </label>
            </div>
          </div>
          {
          _filter(trips, item => (item.tour_id !== CYOA_NETWORK_IDS["europe"].id && item.tour_id !== CYOA_NETWORK_IDS["usa"].id) ).map((item, i) => {
              return (
                <div key={i} className="row margin-t-20">
                  <div className="column small-8 text-left">
                    <p className="bold"><span className="roundal trip"></span>{item.name}</p>
                    <p className="left-space small">{item.descriptions[0]}</p>
                  </div>
                  <div className="column small-4 text-right">
                    <p>
                      {ISOCurrencyCovert(iso_currency)}{ (parseFloat(item.passengers[0].price) + parseFloat(item.passengers[0].accomm_price) - parseFloat(item.passengers[0].discount))  }&nbsp;
                      <span className="currency">{iso_currency}</span>
                    </p>
                  </div>
                </div>
              )
            })
          }

          <div className="row"><div className="column small-12"><hr /></div></div>

          <div className="row margin-b-10 margin-t-10">
            <div className="column small-6 text-left">
              <p className="no-margin">Trip Total:</p>
            </div>
            <div className="column small-6 text-right">
              <p className="no-margin">
                {ISOCurrencyCovert(iso_currency)}{ ((parseFloat(grand_total) + parseFloat(total_paid)) / nr_pax ).toFixed(2) }&nbsp;
                <span className="currency bold">{iso_currency}</span>
              </p>
            </div>
          </div>

          <div className="row margin-b-10">
            <div className="column small-6 text-left">
              <p className="no-margin bold">Subtotal ( x{nr_pax} adults):</p>
            </div>
            <div className="column small-6 text-right">
              <p className="no-margin bold">
                {ISOCurrencyCovert(iso_currency)}{ (parseFloat(grand_total) + parseFloat(total_paid)).toFixed(2) }&nbsp;
                <span className="currency bold">{iso_currency}</span>
              </p>
            </div>
          </div>

          <div style={{display:`${discount === "0.00" ? 'none' : 'block' }` }} className="row margin-b-10">
            <div className="column small-6 text-left">
              <p className="no-margin viking-text">Discount</p>
            </div>
            <div className="column small-6 text-right">
              <p className="no-margin viking-text">
                {ISOCurrencyCovert(iso_currency)}-{discount}&nbsp;
                <span className="currency bold">{iso_currency}</span>
              </p>
            </div>
          </div>

          <div className="row margin-b-10" style={{display:total_paid === "0.00" ? "none" : "block"}}>
            <div className="column small-6 text-left">
              <p className="no-margin bold">Total paid:</p>
            </div>
            <div className="column small-6 text-right">
              <p className="no-margin bold">
                {ISOCurrencyCovert(iso_currency)}{total_paid}&nbsp;
                <span className="currency bold">{iso_currency}</span>
              </p>
            </div>
          </div>

          <div className="row margin-b-10">
            <div className="column small-6 text-left">
              <p className="big bold"> {total_paid === "0.00" ? 'Trip Price:' : 'Balance Due:'}</p>
            </div>
            <div className="column small-6 text-right">
              <p className="big bold orange-text">
                {ISOCurrencyCovert(iso_currency)}{grand_total}&nbsp;
                <span className="currency bold">{iso_currency}</span>
              </p>
            </div>
          </div>

       </div>
      <div className="cyao-info-bar">

        <button type="button" className={`busabout--cta orange edit-button ${total_paid === "0.00" ? "" : "confirmed" }`} onClick={this.onEditClicked}>
          <svg width="16px" height="10px" viewBox="0 0 16 10" version="1.1" xmlns="http://www.w3.org/2000/svg">
              <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                  <g transform="translate(-45.000000, -905.000000)" fillRule="nonzero">
                      <g transform="translate(-5.000000, 70.000000)">
                          <g transform="translate(0.000000, 800.000000)">
                              <g transform="translate(37.000000, 19.000000)">
                                  <g transform="translate(13.000000, 16.000000)">
                                      <path d="M6.01096888,4.99994498 C5.74858038,5.00030616 5.49688655,4.88429355 5.31161544,4.67759374 L3.49471094,2.65633757 L1.67780644,4.67759374 C1.28991347,5.09618358 0.671830724,5.09095459 0.289705114,4.66585039 C-0.0924204955,4.24074618 -0.0971208259,3.55314617 0.279149028,3.12162592 L2.79540696,0.322358339 C2.98085031,0.115960971 3.23241767,0 3.49473567,0 C3.75705368,0 4.00862103,0.115960971 4.19406438,0.322358339 L6.71032232,3.12162592 C6.99315971,3.43632525 7.07776218,3.90956669 6.92468554,4.320711 C6.7716089,4.73185531 6.41099347,4.99994947 6.01096888,5 L6.01096888,4.99994498 Z"></path>
                                      <path d="M6.01096888,9.99994498 C5.74858038,10.0003062 5.49688655,9.88429355 5.31161544,9.67759374 L3.49471094,7.65633757 L1.67780644,9.67759374 C1.28991347,10.0961836 0.671830724,10.0909546 0.289705114,9.66585039 C-0.0924204955,9.24074618 -0.0971208259,8.55314617 0.279149028,8.12162592 L2.79540696,5.32235834 C2.98085031,5.11596097 3.23241767,5 3.49473567,5 C3.75705368,5 4.00862103,5.11596097 4.19406438,5.32235834 L6.71032232,8.12162592 C6.99315971,8.43632525 7.07776218,8.90956669 6.92468554,9.320711 C6.7716089,9.73185531 6.41099347,9.99994947 6.01096888,10 L6.01096888,9.99994498 Z"></path>
                                      <path d="M12.5000495,9.99999916 C12.2372639,10.0003612 11.9851892,9.88407259 11.7996377,9.67688103 L9.2795715,6.87095391 C8.90273219,6.43840707 8.90743963,5.74917123 9.29014357,5.32305569 C9.6728475,4.89694015 10.2918657,4.89169872 10.6803457,5.3112844 L12.5,7.33734919 L14.3196543,5.3112844 C14.7081343,4.89169872 15.3271525,4.89694015 15.7098564,5.32305569 C16.0925604,5.74917123 16.0972678,6.43840707 15.7204285,6.87095391 L13.2003623,9.67688103 C13.0148351,9.88404547 12.7628008,10.0003318 12.5000495,9.99999916 Z"></path>
                                      <path d="M12.5000492,4.99999916 C12.2388554,5.00035949 11.9883076,4.88462063 11.8038801,4.67840858 L9.29907909,1.88574652 C9.04402582,1.60990251 8.94206757,1.2022386 9.03229425,0.819049594 C9.12252092,0.435860587 9.3909331,0.136601485 9.73462388,0.0360056221 C10.0783147,-0.0645902407 10.4439575,0.0490854316 10.6913682,0.333450376 L12.5,2.34993692 L14.3086318,0.333450376 C14.5560425,0.0490854316 14.9216853,-0.0645902407 15.2653761,0.0360056221 C15.6090669,0.136601485 15.8774791,0.435860587 15.9677058,0.819049594 C16.0579324,1.2022386 15.9559742,1.60990251 15.7009209,1.88574652 L13.1961199,4.67840858 C13.0117165,4.88459364 12.7612089,5.00033026 12.5000492,4.99999916 Z"></path>
                                  </g>
                              </g>
                          </g>
                      </g>
                  </g>
              </g>
          </svg>
          Edit Trip
        </button>
        <button type="button" className={`busabout--cta orange itinerary-button ${total_paid === "0.00" ? "" : "confirmed" }`} onClick={this.onItineraryClicked}>

          <svg xmlns="http://www.w3.org/2000/svg" width="75.75" height="74.989" viewBox="0 0 75 74" className="map-svg">
            <g data-name="Layer 2">
              <g data-name="Layer 1">
                <path d="M12.134 43.487a1.5 1.5 0 0 1-1.06-2.56l3.39-3.392-3.39-3.391a1.5 1.5 0 0 1 2.12-2.121l4.453 4.451a1.5 1.5 0 0 1 0 2.121l-4.453 4.452a1.495 1.495 0 0 1-1.06.44zM34.634 43.487a1.5 1.5 0 0 1-1.06-2.56l3.39-3.392-3.39-3.391a1.5 1.5 0 0 1 2.12-2.121l4.452 4.451a1.5 1.5 0 0 1 0 2.121l-4.452 4.452a1.495 1.495 0 0 1-1.06.44zM58.165 43.487a1.5 1.5 0 0 1-1.06-2.56l3.39-3.392-3.39-3.391a1.5 1.5 0 0 1 2.12-2.121l4.452 4.451a1.5 1.5 0 0 1 0 2.121l-4.451 4.452a1.495 1.495 0 0 1-1.061.44z"/>
                <path d="M25.828 74.989a8.992 8.992 0 0 1-3.162-.576l-16.078-6.03A10.198 10.198 0 0 1 0 58.877V4.413a3.807 3.807 0 0 1 1.187-2.992A4.566 4.566 0 0 1 4.94.554a1.996 1.996 0 0 1 .465.113l18.665 7a4.977 4.977 0 0 0 3.725-.085L43.787.728a8.997 8.997 0 0 1 6.344-.282L68.755 6.54a10.13 10.13 0 0 1 6.995 9.648v45.847a10.152 10.152 0 0 1-13.308 9.649l-13.555-4.435a4.989 4.989 0 0 0-3.524.157l-15.99 6.853a8.993 8.993 0 0 1-3.545.73zM4 4.493v54.384a6.18 6.18 0 0 0 3.992 5.76l16.078 6.03a4.982 4.982 0 0 0 3.726-.086l15.991-6.853a8.997 8.997 0 0 1 6.344-.282l13.556 4.435a6.151 6.151 0 0 0 8.063-5.847V16.187a6.137 6.137 0 0 0-4.24-5.847L48.888 4.248a4.986 4.986 0 0 0-3.524.157l-15.99 6.853a8.963 8.963 0 0 1-6.707.155L4.244 4.503A3.772 3.772 0 0 0 4 4.494z"/>
                <path d="M22.402 11.172h-.017a2 2 0 0 1-1.983-2.018l.04-4.36a.24.24 0 0 0-.073-.179.242.242 0 0 0-.179-.075H3.3a2 2 0 1 1 0-4h16.89a4.25 4.25 0 0 1 4.251 4.29l-.039 4.36a2 2 0 0 1-2 1.982zM47 66.527a2 2 0 0 1-2-2V2.009a2 2 0 1 1 4 0v62.518a2 2 0 0 1-2 2z"/>
                <path d="M26 74.983a2 2 0 0 1-2-2V10.527a2 2 0 0 1 4 0v62.456a2 2 0 0 1-2 2z"/>
              </g>
            </g>
          </svg>

          Itinerary / Accommodation
        </button>
        <ul>
          <li>
          <svg xmlns="http://www.w3.org/2000/svg" width="75.315" height="67.558" viewBox="0 0 75 67" className="traveller-svg">
            <g data-name="Layer 2">
              <g data-name="Layer 1">
                <path d="M31.07 57.426H2.072a2 2 0 0 1-1.955-1.577c-.578-2.672 1.02-6.933 3.979-10.6 2.901-3.598 9.582-9.632 21.72-9.632a31.363 31.363 0 0 1 9.636 1.447 2 2 0 0 1-1.228 3.807 27.362 27.362 0 0 0-8.408-1.254c-10.474 0-16.154 5.101-18.607 8.142a15.556 15.556 0 0 0-3.026 5.666H31.07a2 2 0 0 1 0 4z"/>
                <path d="M25.816 39.617a19.809 19.809 0 1 1 18.665-26.455 2 2 0 0 1-3.767 1.342 15.81 15.81 0 1 0-14.898 21.113 15.67 15.67 0 0 0 6.739-1.503 2 2 0 0 1 1.707 3.618 19.637 19.637 0 0 1-8.446 1.885zM61.666 67.558H26.44a2 2 0 0 1-1.955-1.578c-.578-2.672 1.02-6.932 3.979-10.6 2.902-3.597 9.582-9.632 21.721-9.632 10.383 0 16.776 4.37 20.311 8.034a2 2 0 0 1-2.879 2.778c-2.997-3.107-8.454-6.811-17.432-6.811-10.475 0-16.155 5.103-18.608 8.144a15.546 15.546 0 0 0-3.026 5.665h33.115a2 2 0 0 1 0 4z"/>
                <path d="M50.185 49.749A19.809 19.809 0 1 1 69.993 29.94a19.83 19.83 0 0 1-19.807 19.809zm0-35.617A15.809 15.809 0 1 0 65.993 29.94a15.827 15.827 0 0 0-15.807-15.808z"/>
                <path d="M50.084 41.723a10.12 10.12 0 0 1-9.595-6.934 2 2 0 1 1 3.793-1.27 6.107 6.107 0 0 0 11.755-.536 2 2 0 1 1 3.895.91 10.208 10.208 0 0 1-9.848 7.83zM73.315 67.558h-5.322a2 2 0 1 1 0-4h3.322V60.18a2 2 0 0 1 4 0v5.378a2 2 0 0 1-2 2zM25.201 31.59a10.116 10.116 0 0 1-9.594-6.935 2 2 0 0 1 3.793-1.267 6.124 6.124 0 0 0 5.8 4.203 6.582 6.582 0 0 0 6.386-4.45 2 2 0 1 1 3.865 1.03 10.541 10.541 0 0 1-10.25 7.42zM31.07 57.426H2.072a2 2 0 0 1-1.955-1.577c-.578-2.672 1.02-6.933 3.979-10.6 2.901-3.598 9.582-9.632 21.72-9.632a31.363 31.363 0 0 1 9.636 1.447 2 2 0 0 1-1.228 3.807 27.362 27.362 0 0 0-8.408-1.254c-10.474 0-16.154 5.101-18.607 8.142a15.556 15.556 0 0 0-3.026 5.666H31.07a2 2 0 0 1 0 4z"/>
                <path d="M25.816 39.617a19.809 19.809 0 1 1 18.665-26.455 2 2 0 0 1-3.767 1.342 15.81 15.81 0 1 0-14.898 21.113 15.67 15.67 0 0 0 6.739-1.503 2 2 0 0 1 1.707 3.618 19.637 19.637 0 0 1-8.446 1.885zM61.666 67.558H26.44a2 2 0 0 1-1.955-1.578c-.578-2.672 1.02-6.932 3.979-10.6 2.902-3.597 9.582-9.632 21.721-9.632 10.383 0 16.776 4.37 20.311 8.034a2 2 0 0 1-2.879 2.778c-2.997-3.107-8.454-6.811-17.432-6.811-10.475 0-16.155 5.103-18.608 8.144a15.546 15.546 0 0 0-3.026 5.665h33.115a2 2 0 0 1 0 4z"/>
                <path d="M50.185 49.749A19.809 19.809 0 1 1 69.993 29.94a19.83 19.83 0 0 1-19.807 19.809zm0-35.617A15.809 15.809 0 1 0 65.993 29.94a15.827 15.827 0 0 0-15.807-15.808z"/>
                <path d="M50.084 41.723a10.12 10.12 0 0 1-9.595-6.934 2 2 0 1 1 3.793-1.27 6.107 6.107 0 0 0 11.755-.536 2 2 0 1 1 3.895.91 10.208 10.208 0 0 1-9.848 7.83zM73.315 67.558h-5.322a2 2 0 1 1 0-4h3.322V60.18a2 2 0 0 1 4 0v5.378a2 2 0 0 1-2 2zM25.201 31.59a10.116 10.116 0 0 1-9.594-6.935 2 2 0 0 1 3.793-1.267 6.124 6.124 0 0 0 5.8 4.203 6.582 6.582 0 0 0 6.386-4.45 2 2 0 1 1 3.865 1.03 10.541 10.541 0 0 1-10.25 7.42z"/>
              </g>
            </g>
          </svg>
            x { nr_pax }
          </li>
          <li>
            <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" className="days-svg">
              <g fill="none" fillRule="evenodd">
                <path d="M11.7 10.4H9.85a.52.52 0 0 1-.52-.52V8.02a.52.52 0 0 1 1.04 0v1.34h1.35a.52.52 0 1 1 0 1.04" fill="#F60"/>
                <g transform="translate(0 -.24)">
                  <path d="M9.85 1.33a8.81 8.81 0 0 0-8.81 8.8 8.81 8.81 0 0 0 17.63 0c0-4.86-3.96-8.8-8.82-8.8m0 18.62A9.85 9.85 0 0 1 0 10.12a9.85 9.85 0 0 1 19.7 0 9.85 9.85 0 0 1-9.85 9.83" fill="#F60" mask="url(#b)"/>
                </g>
                <path d="M9.85 2.95A6.95 6.95 0 0 0 2.9 9.88a6.95 6.95 0 0 0 13.9 0 6.95 6.95 0 0 0-6.95-6.93m0 14.9a7.98 7.98 0 0 1-7.98-7.97 7.98 7.98 0 0 1 15.97 0c0 4.39-3.58 7.96-7.99 7.96" fill="#F60"/>
                <path d="M9.72 4.83a.52.52 0 0 1-.52-.51V2.46a.52.52 0 0 1 1.04 0v1.86c0 .28-.24.51-.52.51M4.28 10.26H2.4a.52.52 0 1 1 0-1.03h1.87a.52.52 0 1 1 0 1.03M9.72 17.55a.52.52 0 0 1-.52-.52v-1.86a.52.52 0 0 1 1.04 0v1.86c0 .29-.24.52-.52.52M17.02 10.26h-1.86a.52.52 0 1 1 0-1.03h1.86a.52.52 0 1 1 0 1.03" fill="#F60"/>
              </g>
            </svg>
            { nr_days + 1 } days
          </li>
          <li>
            <svg width="17" height="21" viewBox="0 0 17 21" xmlns="http://www.w3.org/2000/svg" className="city-svg">
              <g fill="none" fillRule="evenodd">
                <path d="M8.34 3.97a3.46 3.46 0 1 0 0 6.92 3.46 3.46 0 0 0 0-6.92m0 8.02a4.57 4.57 0 1 1 0-9.13 4.57 4.57 0 0 1 0 9.13" fill="#F60"/>
                <path d="M8.34 5.98a1.45 1.45 0 1 0 0 2.9 1.45 1.45 0 0 0 0-2.9m0 4a2.56 2.56 0 1 1 0-5.12 2.56 2.56 0 0 1 0 5.12" fill="#F60"/>
                <g>
                  <path d="M11.24 18a.55.55 0 0 1-.45-.88c1.03-1.42 3.8-5.37 4.25-6.54.35-.9.53-1.69.53-2.35a7.2 7.2 0 0 0-2.11-5.28A6.85 6.85 0 0 0 8.31 1.1a6.84 6.84 0 0 0-5.1 1.84 7.19 7.19 0 0 0-2.1 5.28c0 .57.12 1.23.38 1.97.43 1.25 3.55 5.4 4.7 6.9a.55.55 0 0 1-.86.68C4.89 17.2 1 12.2.44 10.56A7.28 7.28 0 0 1 0 8.23c0-2.41.87-4.57 2.45-6.08A7.94 7.94 0 0 1 8.34 0c2.25-.1 4.34.66 5.88 2.14a8.28 8.28 0 0 1 2.45 6.08c0 .8-.2 1.73-.6 2.75-.6 1.54-4.23 6.57-4.38 6.78a.55.55 0 0 1-.45.23" fill="#F60" mask="url(#b)"/>
                </g>
                <g transform="translate(6 18)">
                  <path d="M2.34 3a.55.55 0 0 1-.4-.16L.71 1.6A.55.55 0 1 1 1.5.83l.84.84.84-.84a.55.55 0 1 1 .78.78L2.73 2.84c-.11.1-.25.16-.4.16" fill="#F60" mask="url(#d)"/>
                </g>
              </g>
            </svg>
            { nr_cities } cities
          </li>
          <li className="">
            <svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" className="coach-svg">
              <g fill="#F60" fillRule="nonzero">
                <path d="M9.5 16.2a43 43 0 0 1-5.2-.3c-1-.1-1.6-.9-1.6-1.8v-10C2.7 2 4.6 0 6.9 0H12c2.3 0 4.2 1.9 4.2 4.2v10c0 .8-.7 1.6-1.6 1.7a43 43 0 0 1-5.1.3zM6.9 1a3.2 3.2 0 0 0-3.2 3.2v10c0 .3.3.7.7.7a42 42 0 0 0 10.1 0c.4 0 .7-.4.7-.8v-10C15.2 2.5 13.8 1 12 1H7z"/>
                <path d="M3.2 3.6c-.3 0-.5-.2-.5-.4 0-.3.2-.5.5-.5h12.5c.3 0 .5.2.5.4 0 .3-.2.5-.5.5H3.2zM15.7 9.9H3.2c-.3 0-.5-.2-.5-.5 0-.2.2-.4.5-.4h12.5c.3 0 .5.2.5.4 0 .3-.2.5-.5.5zM6.8 18h-1c-.7 0-1.3-.5-1.3-1v-1.3c0-.1 0-.2.2-.3l.3-.1 2.6.2c.3 0 .5.2.5.4v1c0 .6-.6 1.1-1.3 1.1zm-1.3-1.8v.7c0 .2.2.3.3.3h1c.1 0 .3-.1.3-.3v-.6l-1.6-.1zM13 18h-.9c-.7 0-1.3-.6-1.3-1.4v-1.4c0-.2.2-.5.5-.5l2.5-.3.4.1.2.4v1.7c0 .8-.6 1.4-1.3 1.4zm-1.2-2.3v.9c0 .2.2.3.3.3h1c.1 0 .3-.1.3-.3v-1l-1.6.1zM11.2 11.7H7.7c-.3 0-.5-.2-.5-.4 0-.3.2-.5.5-.5h3.5c.3 0 .5.2.5.4 0 .3-.2.5-.5.5zM11.2 13.5H7.7c-.3 0-.5-.2-.5-.4 0-.3.2-.5.5-.5h3.5c.3 0 .5.2.5.5 0 .2-.2.4-.5.4zM11.2 2.7H7.7c-.3 0-.5-.2-.5-.5 0-.2.2-.4.5-.4h3.5c.3 0 .5.2.5.4 0 .3-.2.5-.5.5z"/>
                <path d="M17.5 5.4a.5.5 0 0 1-.5-.5 1 1 0 0 0-.4-.8c-.7-.5-1.6-.4-1.6-.4a.5.5 0 0 1-.6-.4c0-.3.2-.5.4-.6.1 0 1.4-.2 2.4.6.5.4.8 1 .8 1.6 0 .3-.2.5-.5.5z"/>
                <path d="M17.6 8.1h-.5c-.5 0-.9-.6-.9-1.3V5c0-.3.2-.5.4-.5h1c.2 0 .4.2.4.5v2.6c0 .3-.2.5-.4.5zM17 5.6v1.2l.1.2h.1V5.6H17zM.5 5.4a.5.5 0 0 1-.5-.5c0-.6.3-1.2.8-1.6 1-.8 2.3-.6 2.4-.6.2 0 .4.3.4.6s-.3.5-.6.5c0 0-1-.2-1.6.3A1 1 0 0 0 1 5c0 .3-.2.5-.5.5z"/>
                <path d="M.9 8.1H.4c-.2 0-.4-.2-.4-.5V5c0-.3.2-.5.4-.5h1c.2 0 .4.2.4.5v1.8c0 .7-.4 1.3-1 1.3zm-.1-1l.2-.3V5.6H.8V7zM5 13.5H3.2c-.3 0-.5-.2-.5-.5v-1.7c0-.3.2-.5.5-.5H5c.7 0 1.3.5 1.3 1v.6c0 .6-.6 1.1-1.3 1.1zm-1.2-1h1.4v-.6c0-.1 0-.2-.2-.2H3.8v.9zM15.7 13.5h-1.8c-.7 0-1.3-.5-1.3-1v-.6c0-.6.6-1.1 1.3-1.1h1.8c.3 0 .5.2.5.5V13c0 .2 0 .3-.2.4l-.3.1zm-1.8-1.8c-.1 0-.2 0-.2.2v.5c0 .1 0 .2.2.2H15v-.9H14zM12.2 8.1a.5.5 0 1 1 0-1h1.1V5.8a.5.5 0 0 1 1.1 0v1.7c0 .2-.2.5-.5.5h-1.7z"/>
              </g>
            </svg>
            { nr_stops } coach trips
          </li>
        </ul>

        <button type="button" className={`busabout--cta orange book-button float-right ${total_paid === "0.00" ? "" : "confirmed"}`} onClick={this.onBookClicked} onMouseOut={() => this.totalMouseOut()} onMouseOver={() => this.totalMouseOver()}>
          <span style={{display: total_paid === "0.00" ? 'block' : "none"}}>Book now</span>
          <span style={{display: total_paid !== "0.00" ? 'block' : "none"}}>Booking confirmed</span>
        </button>

        <div className={`total-box float-right ${total_paid === "0.00" ? "" : "confirmed" }`} onMouseOut={() => this.totalMouseOut()} onMouseOver={() => this.totalMouseOver()}>
          <div className="row">
            <div className="column small-12">
              <p className="total-text uppercase no-margin">{total_paid === "0.00" ? "Total price" : "Balance due"}</p>

              <p className="price-text no-margin bold">
                &nbsp;&nbsp;{ISOCurrencyCovert(iso_currency)}{grand_total}&nbsp;
                <span className="currency bold">{iso_currency}</span>
              </p>

            </div>


            <div className="column small-12">
              <p className="accommodation-text no-margin">{`Accommodation ${accomm_total !== "0.00" ? "" : "not"} included`}</p>
            </div>
          </div>

        </div>

      </div>
      </Fragment>
    )
  }
}


function mapStateToProps(state){
  return {
    itineraries:state.itineraries.data,
    hasAccomodation:state.currentBooking.accommodation
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    PostIntinerariesAccomodation
  }, dispatch);
}


export default connect(mapStateToProps, mapDispatchToProps)(Infobar);



// WEBPACK FOOTER //
// ./src/components/itinerary/components/info-bar.js